import React, { useCallback } from 'react';
import { FormContainer } from '../containers/FormContainer';
const FormPanel = ({ chartMode, setChartMode, formData, synastryData, onFormChange, onSynastryChange, onRadioChange, onSynastryRadioChange, onShowHistory, onSubmit, onSynastrySubmit, onSaveHistory, updateUrlParams, setShowAstrolabe, setShowInputPanel, }) => {
    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        if (!formData.year || !formData.month || !formData.day) {
            alert("请填写完整的日期信息（年、月、日）");
            return;
        }
        // 如果有姓名，保存到历史记录
        if (formData.name.trim()) {
            onSaveHistory({
                ...formData,
                type: 'single'
            });
        }
        updateUrlParams(formData);
        setShowAstrolabe(true);
        setShowInputPanel(false);
    }, [formData, onSaveHistory, updateUrlParams, setShowAstrolabe, setShowInputPanel]);
    const handleSynastrySubmit = useCallback((e) => {
        e.preventDefault();
        if (!synastryData.person1.year || !synastryData.person1.month || !synastryData.person1.day) {
            alert("请填写第一个人的完整日期信息（年、月、日）");
            return;
        }
        if (!synastryData.person2.year || !synastryData.person2.month || !synastryData.person2.day) {
            alert("请填写第二个人的完整日期信息（年、月、日）");
            return;
        }
        // 如果有任意一个人的姓名，保存到历史记录
        if (synastryData.person1.name.trim() || synastryData.person2.name.trim()) {
            onSaveHistory({
                ...synastryData.person1,
                type: 'synastry',
                person2: synastryData.person2
            });
        }
        setShowAstrolabe(true);
        setShowInputPanel(false);
    }, [synastryData, onSaveHistory, setShowAstrolabe, setShowInputPanel]);
    return (React.createElement(FormContainer, { chartMode: chartMode, setChartMode: setChartMode, formData: formData, synastryData: synastryData, onFormChange: onFormChange, onSynastryChange: onSynastryChange, onRadioChange: onRadioChange, onSynastryRadioChange: onSynastryRadioChange, onShowHistory: onShowHistory, onSubmit: handleSubmit, onSynastrySubmit: handleSynastrySubmit }));
};
export default React.memo(FormPanel);
